module.exports = __webpack_public_path__ + "static/20141025_132251-6e090e8d17e3437b04b944abf75d1664.jpg";